import useSWR from "swr";
import { useToken } from "../auth/token";
import { useApiClient } from "@/app/contexts/DemoTradeContext";

export function useTradeOrder(ep_id) {
  const { data: token, getLatestToken } = useToken();
  const { api } = useApiClient(); // ✅ Context에서 API 클라이언트 가져오기
  const KEYURL = "/trade/orderlist?status=1&ep_id=" + ep_id;

  const { data, mutate } = useSWR(
    !ep_id || !token ? null : KEYURL,
    async () => {
      const currentToken = getLatestToken();
      // ✅ Context를 통해 Demo/Real API 자동 선택
      const response = await api.get(KEYURL, currentToken + "", {}, false);
      // console.log("useTradeOrder", response);
      return response?.result || [];
    },
    { revalidateOnFocus: true, refreshInterval: 0 }
  );

  return {
    data,
    mutate,
  };
}
